module.exports = __webpack_public_path__ + "img/ojon2020.e784558e.jpg";